import {connect} from 'react-redux';
import {reduxForm} from 'redux-form';
import {ff, form, Loader, utils} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
const {Form, FormActions, FormBody} = form;
import CustomCheckboxField from "../components/CustomCheckboxField";
import * as objednavkaActions from "../actions/objednavkaActions";
import {withTranslation, WithTranslation} from "react-i18next";

// řetězec musí přesně odpovídat tomu, který se vrací z ObjednavkaController.vratSeznamSmj(),
// tj. z externího PDF parseru a nesmí se tedy měnit!
export const ZE_SLOZKY = 'Počítat *.pdf ze složky zakázky';
export const KOD_UKON_SKLADAT = 'SKLADAT';

/**
 * Formulář pro import fakturačních položek.
 */
class ImportForm extends Component<WithTranslation> {

    static formName = 'ImportForm';

    componentDidMount() {
        this.fetchData(true); // MCV-56526
    }

    componentDidUpdate() {
        this.fetchData();
    }

    fetchData = (force = false) => {
        this.props.dispatch(objednavkaActions.fetchObjednavkaSmjIfNeeded(force));
    };

    renderFileName = (item) => {
        if (item === ZE_SLOZKY) { // zvláštní případ, který chceme jako jediný překládat
            return this.props.t('calculate_from_folder');
        }
        return item ? item : "";
    };

    render() {
        const {onClose, submitting, handleSubmit, seznamSmjList, t} = this.props;

        if (!seznamSmjList.fetched || seznamSmjList.isFetching) {
            return <Loader/>;
        }

        return <Form onSubmit={handleSubmit} horizontal>
            <FormBody>
                <ff.ObjectSuggest
                    label={t('file_import_name')}
                    name="soubor"
                    disabled={seznamSmjList.rows.length === 0}
                    dropdown={true}
                    removable={false}
                    getItemValue={this.renderFileName}
                    renderSuggestion={this.renderFileName}
                    items={seznamSmjList.rows}
                />
                <ff.Number int label={t('labels._default_count')} name="pocet" disabled={submitting}/>
                <CustomCheckboxField label={t('labels.compose')} name="skladat" disabled={submitting} title={t('labels.compose_hint', {code: KOD_UKON_SKLADAT})}/>
            </FormBody>
            <FormActions onClose={onClose} submitButton={t('confirm')} cancelButton={t('buttons.cancel')} disabled={submitting}/>
        </Form>
    }
}

function mapStateToProps(state) {
    return {
        seznamSmjList: utils.storeFromArea(state, objednavkaActions.OBJEDNAVKA_SEZNAM_SMJ_AREA),
    }
}

export default withTranslation()(connect(mapStateToProps)(reduxForm({
    form: ImportForm.formName,
})(ImportForm)));
